import { useMemo } from 'react';

import { useAISmartButtonActions } from '../../ai-smart-button-store';

/**
 * Hook for managing presentation view of ai actions.
 */
export const useViewAIActions = () => {
	const { changeView, setProfileData } = useAISmartButtonActions();
	return useMemo(
		() => ({
			/**
			 * Change the view of the ai actions.
			 */
			changeView,
			/**
			 * Set the prefetched name for the ai actions.
			 */
			setProfileData,
		}),
		[changeView, setProfileData],
	);
};

export type ViewAIActions = ReturnType<typeof useViewAIActions>;
